var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "credit-card-required-container",
        { "admin-view": _vm.hasPermission },
      ],
    },
    [
      _c("div", { staticClass: "warning-card" }, [
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "card-info" }, [
            _c("div", { staticClass: "alert-icon" }, [
              _c(
                "svg",
                {
                  attrs: {
                    viewBox: "0 0 24 24",
                    width: "32",
                    height: "32",
                    stroke: "#e74c3c",
                    "stroke-width": "2",
                    fill: "none",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z",
                    },
                  }),
                  _vm._v(" "),
                  _c("line", {
                    attrs: { x1: "12", y1: "9", x2: "12", y2: "13" },
                  }),
                  _vm._v(" "),
                  _c("line", {
                    attrs: { x1: "12", y1: "17", x2: "12.01", y2: "17" },
                  }),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card-message" }, [
              _c("h3", [_vm._v(_vm._s(_vm.$t("message.creditCardRequired")))]),
              _vm._v(" "),
              _vm.hasPermission
                ? _c("p", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.$t("message.creditCardRequiredDescription")
                        ) +
                        "\n                    "
                    ),
                  ])
                : _c("p", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.$t("message.creditCardRequiredDescription2")
                        ) +
                        "\n                    "
                    ),
                  ]),
            ]),
          ]),
          _vm._v(" "),
          _vm.hasPermission
            ? _c(
                "div",
                { staticClass: "card-actions" },
                [
                  _c(
                    "SupsisButton",
                    {
                      attrs: { primary: "" },
                      on: { click: _vm.openPaymentModal },
                    },
                    [_vm._v(_vm._s(_vm.$t("message.addCreditCard")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "SupsisButton",
                    {
                      attrs: { ghost: "" },
                      on: { click: _vm.openManageModal },
                    },
                    [_vm._v(_vm._s(_vm.$t("message.subscriptionManagement")))]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.hasPermission
            ? _c("div", { staticClass: "no-permission-info" }, [
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("message.noPermissionDescription")
                    ),
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "support-action" },
                  [
                    _c(
                      "SupsisButton",
                      {
                        attrs: { primary: "" },
                        on: { click: _vm.connectSupport },
                      },
                      [_vm._v(_vm._s(_vm.$t("message.liveSupport")))]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "features-container" }, [
        _c("div", { staticClass: "feature-box" }, [
          _c("div", { staticClass: "feature-icon" }, [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "#22272d",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              },
              [
                _c("rect", {
                  attrs: {
                    x: "2",
                    y: "7",
                    width: "20",
                    height: "14",
                    rx: "2",
                    ry: "2",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: { d: "M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" },
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("h4", [_vm._v(_vm._s(_vm.$t("message.annualDiscount")))]),
          _vm._v(" "),
          _c("p", [
            _vm._v(_vm._s(_vm.$t("message.annualDiscountDescription"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "feature-box" }, [
          _c("div", { staticClass: "feature-icon" }, [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "#22272d",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              },
              [
                _c("line", {
                  attrs: { x1: "12", y1: "1", x2: "12", y2: "23" },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6",
                  },
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("h4", [_vm._v(_vm._s(_vm.$t("message.payOnlyForUsedFeatures")))]),
          _vm._v(" "),
          _c("p", [
            _vm._v(_vm._s(_vm.$t("message.payOnlyForUsedFeaturesDescription"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "feature-box" }, [
          _c("div", { staticClass: "feature-icon" }, [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "#22272d",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              },
              [_c("polyline", { attrs: { points: "18 15 12 9 6 15" } })]
            ),
          ]),
          _vm._v(" "),
          _c("h4", [_vm._v(_vm._s(_vm.$t("message.cancelAnytime")))]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.$t("message.cancelAnytimeDescription")))]),
        ]),
      ]),
      _vm._v(" "),
      _vm.isModalVisible
        ? _c(
            "Modal2",
            {
              attrs: {
                showFooter: false,
                showTitle: false,
                className: "payment-modal",
              },
              on: { cancel: _vm.closeModal },
            },
            [
              _c("PaymentSteps", {
                ref: "paymentSteps",
                on: { cancel: _vm.closeModal, submit: _vm.savePaymentInfo },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("SubscriptionManagementModal", {
        attrs: { visible: _vm.isManageModalVisible },
        on: {
          cancel: function ($event) {
            _vm.isManageModalVisible = false
          },
          unsubscribe: _vm.handleUnsubscribe,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }